/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/*import url and gateway methods */
import { getData, putData, deleteData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import get current date in string
import { getCurrentDateInString } from "helper/EventHelper/EventHelper";

import RecivedInviteTab from "../Tabs/RecivedInviteTab";
import SentInviteTab from "../Tabs/SentInviteTab";

const MyInviteBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [showRecievedTab, setshowRecievedTab] = useState(false);
  const [showSentTab, setshowSentTab] = useState(false);

  const [modalMessage, setModalMessage] = useState();
  const [modalSubMessage, setModalSubMessage] = useState("");
  const [recievedInviteList, setRecievedInviteList] = useState([]);
  const [sentRequestList, setSentRequestList] = useState([]);

  const toggleTabHandler = (tabName) => {
    setshowRecievedTab(false);
    setshowSentTab(false);

    if (tabName == "recieved") {
      setshowRecievedTab(true);
    }

    if (tabName == "sent") {
      setshowSentTab(true);
    }
  };

  //function for get all invite
  const getAllInvites = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GET_ALL_RECIEVED_INVITE + `?token=${token}`;

      const response = await getData(requestURL);

      console.log(response);

      if (response.status) {
        setRecievedInviteList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get all sent requests
  const getAllSentRequests = async () => {
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GET_ALL_SEND_INVITE + `?token=${token}`;

      const response = await getData(requestURL);

      console.log(response);

      if (response.status) {
        setSentRequestList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for accept invite
  const acceptHandler = async (contactId) => {
    try {
      let inviteData = {
        memberstatus: "1",
        connecteddate: getCurrentDateInString(),
      };

      let requestURL =
        url.API_BASE_URL +
        url.API_ACCEPT_INVITE +
        `/${contactId}?token=${token}`;

      const response = await putData(requestURL, inviteData);

      if (response.status) {
        // setModalMessage("Invite accpet Successfully");
        // setModalSubMessage("Invite request has been successfully added");
        // //show register modal
        // let myModal = new bootstrap.Modal(
        //   document.getElementById("invite_success_mdl")
        // );
        // myModal.show();
        getAllInvites();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for reject invite
  const rejectInviteHandler = async (personId) => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_REJECT_CONTACT_REQUEST +
        `?token=${token}&personid=${personId}`;

      const response = await deleteData(requestURL);

      console.log(response);

      if (response.status) {
        // setModalMessage("Invite rejected Successfully");
        // setModalSubMessage("Invite request has been successfully rejected");
        // //show register modal
        // let myModal = new bootstrap.Modal(
        //   document.getElementById("invite_success_mdl")
        // );
        // myModal.show();
        getAllInvites();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const afterModalClose = () => {
    setModalMessage("");
    setModalSubMessage("");
    getAllInvites();
  };

  useEffect(() => {
    getAllInvites();
    getAllSentRequests();
    setshowRecievedTab(true);
  }, []);

  return (
    <section className="inner_sec">
      <div className="container-fluid">
        <div className="notication_bx white_shadow_bx bg_white p-3">
          <div className="contact_header mb-4">
            <div className="contact_hdng_row d-flex align-items-center justify-content-between">
              <div className="post_hdng mb-3">
                <h4 className="fs-lg text-primary fw-semibold">
                  Manage Requests
                </h4>
              </div>
            </div>
            {/* <div className="contact_srch">
              <input
                type="text"
                className="form-control body_bg"
                placeholder="Search"
              />


              <div className="search_list">
                <div className="srch_row d-flex align-items-center justify-content-between">
                  <div className="srch_name_left d-flex align-items-center">
                    <i className="material-icons-outlined">history</i>
                    <span>Richa Holmowalk</span>
                  </div>
                  <Link to="#" className="srch_name_cross">
                    <i className="material-icons-outlined">close</i>
                  </Link>
                </div>
                <div className="srch_row d-flex align-items-center justify-content-between">
                  <div className="srch_name_left d-flex align-items-center">
                    <i className="material-icons-outlined">history</i>
                    <span>David Anderson</span>
                  </div>
                  <Link to="#" className="srch_name_cross">
                    <i className="material-icons-outlined">close</i>
                  </Link>
                </div>
                <div className="srch_row d-flex align-items-center justify-content-between">
                  <div className="srch_name_left d-flex align-items-center">
                    <i className="material-icons-outlined">history</i>
                    <span>Alan Benjamin</span>
                  </div>
                  <Link to="#" className="srch_name_cross">
                    <i className="material-icons-outlined">close</i>
                  </Link>
                </div>
                <div className="srch_row d-flex align-items-center justify-content-between">
                  <div className="srch_name_left d-flex align-items-center">
                    <i className="material-icons-outlined">history</i>
                    <span>Lester Disusa</span>
                  </div>
                  <Link to="#" className="srch_name_cross">
                    <i className="material-icons-outlined">close</i>
                  </Link>
                </div>
                <div className="srch_row d-flex align-items-center justify-content-between">
                  <div className="srch_name_left d-flex align-items-center">
                    <i className="material-icons-outlined">history</i>
                    <span>Richa Holmowalk</span>
                  </div>
                  <Link to="#" className="srch_name_cross">
                    <i className="material-icons-outlined">close</i>
                  </Link>
                </div>
              </div>
            </div> */}
            {/* tab header */}
            <div className="login_tabs">
              <ul className="nav nav-tabs list_stye_none">
                <li className="nav-item">
                  <Link
                    className={
                      showRecievedTab ? "nav-link active show" : "nav-link"
                    }
                    to="#"
                    onClick={() => {
                      toggleTabHandler("recieved");
                    }}
                  >
                    Recieved
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={
                      showSentTab ? "nav-link active show" : "nav-link"
                    }
                    to="#"
                    onClick={() => {
                      toggleTabHandler("sent");
                    }}
                  >
                    Sent
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {showRecievedTab && (
            <RecivedInviteTab
              inviteList={recievedInviteList}
              acceptHandler={acceptHandler}
              rejectInviteHandler={rejectInviteHandler}
            />
          )}

          {showSentTab && <SentInviteTab inviteList={sentRequestList} />}
        </div>
      </div>
    </section>
  );
};

export default MyInviteBody;
